import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { Faq } from "../interfaces/Faq";
import parse from 'html-react-parser';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MainLayout } from "../layout/MainLayout";
import { LoadingSpinner } from "../elements/LoadingSpinner";
import { handleApiError, safeJsonParse } from "../../utils/api";

export default function FaqsPage() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [faqs, setFaqs] = useState<Faq[]>([]);
    const [faqsLoaded, setFaqsLoaded] = useState(false);

    useEffect(() => {
        const currentLang = i18n.language || 'en';

        fetch(import.meta.env.VITE_API_URL + `/v1/faq?lang=${currentLang}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        })
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                setFaqs(data);
                setFaqsLoaded(true);
            });
    }, [i18n.language]);

    return (
        <MainLayout>
            <div className="container-fluid">
                <div className="row">
                    <h2>FAQs</h2>
                </div>
                <div className="faqs-page">
                    <div className="message margin-bottom">
                        {t("Check out some of the questions teachers/designers have asked us so far. The answers will help you to get the most of the tool")}
                    </div>
                    <div className="faqs-list">
                        {!faqsLoaded && <LoadingSpinner />}
                        {faqsLoaded &&
                            <Accordion>
                                {faqs.map((f: Faq, index) => {
                                    const currentLang = i18n.language || 'en';
                                    const translation = f.translations.find(t => t.lang === currentLang) ||
                                        f.translations.find(t => t.lang === f.defaultLang) ||
                                        f.translations[0];

                                    if (!translation) return null;

                                    return <Accordion.Item key={'event-key-' + index} eventKey={'event-key-' + index}>
                                        <Accordion.Header>{translation.title}</Accordion.Header>
                                        <Accordion.Body>{parse(translation.body)}</Accordion.Body>
                                    </Accordion.Item>
                                })}
                            </Accordion>
                        }
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}
